import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  isLoading: WritableSignal<boolean> = signal<boolean>(false);
  endTestPopup: WritableSignal<boolean> = signal<boolean>(false);

  formatDateTimeGeneric(input?: string, useUTC: boolean = false): string {
    const date = input ? new Date(input) : new Date();

    const pad = (num: number): string => num.toString().padStart(2, "0");

    const day = pad(useUTC ? date.getUTCDate() : date.getDate());
    const month = pad(useUTC ? date.getUTCMonth() + 1 : date.getMonth() + 1);
    const year = useUTC ? date.getUTCFullYear() : date.getFullYear();
    const hours = pad(useUTC ? date.getUTCHours() : date.getHours());
    const minutes = pad(useUTC ? date.getUTCMinutes() : date.getMinutes());
    const seconds = pad(useUTC ? date.getUTCSeconds() : date.getSeconds());

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }
}
